import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'

const fetcher = (...args: any[]) => {
	if (args[0]?.includes('undefined')) {
		return []
	}
	try {
		// @ts-ignore
		return fetch(...args).then((res) => res.json())
	} catch {
		return []
	}
}

export default function useRuneOutpoints(
	rune_id: string,
	address?: string
): {
	data: any[]
	isLoading: boolean
} {
	return useSwr(
		`${API_URL}/wallet/${address || Wallet.getTaprootAddress()}/rune-outpoints/${rune_id}`,
		fetcher
	)
}
